<template>
  <div class="wrapper">
    <div class="container">
      <h3>获取APPID</h3>
      <div class="section">
        <div class="lable-name">法人微信号（企业、个体户用户，必须填写法人微信号）</div>
        <input v-model="wechat" placeholder="输入微信号" placeholder-style="color:#C1CBD7;" maxlength="20" class="wechat" />
      </div>
      <div class="btn" @click="getAppId">获取</div>
      <router-link :to="{path: '/register-mp?shopCode='+shopCode}" class="jump-btn">跳过</router-link>
      <!-- <router-link :to="{path: '/result?shopCode='+shopCode}" class="jump-btn">跳过</router-link> -->
    </div>
  </div>
</template>
<script>
import { getAppId} from '@/api/register';
export default {
  name: 'storeList',
  data() {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      shopCode: null,
      wechat: ''
    }
  },
  created() {
    if(this.$route.query){
      this.shopCode = this.$route.query.shopCode;
    }
  },
  methods: {
    getAppId() {
      let params = {
        shopCode: this.shopCode,
        wxUser: this.wechat
      }
      if(this.wechat==='') return this.Toast('请输入微信号~');
      getAppId(params).then(res => {
        if(res.code === 200) {
          this.Toast('APPID获取成功~');
          setTimeout(() => {
            this.$router.push({
              // path: '/result?shopCode=' + this.shopCode
              path: '/register-mp?shopCode=' + this.shopCode
            })
          }, 1500);
          
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  height: 100%;
  h3{
    width: 100%;
    line-height: 1.4;
    font-size: 18px;
    color: #222;
    text-align: center;
    margin: 44px 0;
  }
  .btn{
    height: 48px;
    line-height: 48px;
    background: #47B6C7;
    border-radius: 10px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    margin: 20px 38px;
    cursor: pointer;
  }
  .jump-btn{
    margin-top: 20px;
    font-size: 16px;
    color: #47B6C7;
    text-align: center;
    display: block;
  }
}
.section{
  margin: 0 38px;
  .lable-name{
    line-height: 1.4;
    font-size: 14px;
    color: #8F8F94;
    text-align: left;
  }
  .wechat{
    width: 100%;
    line-height: 20px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #D8E0F0;
    font-size: 18px;
    color: #222;
    text-align: left;
    border: 1px solid #D8E0F0;
    padding: 15px 10px;
    box-sizing: border-box;
    margin-top: 10px;
  }
}
@media screen and (max-width:750px){
  
}
@media screen and (min-width:750px){
  
}
</style>


// WEBPACK FOOTER //
// src/views/appId.vue